import React from 'react';

import WelcomeScreen from '../components/Welcome';

const LegalPage: React.FC = () => {	
	return (
		<div className="min-h-screen bg-primary">
			<WelcomeScreen />
			
			<div className='flex justify-center'>
				<div className='pl-5 pr-5 max-w-4xl'>
					<h1 className="text-2xl font-bold text-white text-center">Legal</h1>

					<p className="text-white text-center mt-5">
						Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates, quia sit sed nisi possimus veritatis laborum neque velit culpa nulla, quo, libero praesentium hic consequuntur. Odio odit soluta ab est.
					</p>
				</div>
			</div>
			
		</div>
	);
};

export default LegalPage;